module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "select-container clearfix",
    staticStyle: {
      "margin-top": "2%",
      "margin-left": "2%",
      "float": "left"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "38px",
      "font-weight": "bold"
    }
  }, [_vm._v("其它 FAQ")]), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("1、如何判断是否成功安装MOA")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("MOA安装完成后，首次运行需要"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("使用自己的手机大象扫码")]), _vm._v("，在看到类似如下的MOA界面后，说明安装成功。")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("../assets/other_FAQ/other_FAQ_pic01.png"),
      "width": "600px",
      "height": "370px"
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("2、提供给6000同学安装状态查询接口")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("安装状态查询接口："), _c('a', {
    staticClass: "ct-link",
    staticStyle: {
      "color": "#1890ff"
    },
    attrs: {
      "data-auto_update": "0",
      "data-pageid": "",
      "href": "https://report-mon.sankuai.com/report/api/check_status?mis_id=wangzepeng05",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("https://report-mon.sankuai.com/report/api/check_status?mis_id=wangzepeng05")])]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("../assets/other_FAQ/other_FAQ_pic02.png"),
      "width": "1000px",
      "height": "80px"
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("3、如何修改MOA绑定的mis号")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("当前不支持mis号修改")]), _vm._v("，所以一定要提醒同事安装时"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("用自己的手机大象扫码")]), _vm._v("。")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("4、申请MOA白名单条件及申请流程")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("MOA不支持的系统：Windows xp、Linux（Ubuntu等）")]), _vm._v(" "), _c('p', [_vm._v("申请流程：如工作需要，不能从Windows XP 升级到Windows 7或Windows 10，可参考"), _c('a', {
    staticClass: "ct-link",
    staticStyle: {
      "color": "#1890ff"
    },
    attrs: {
      "data-auto_update": "0",
      "data-pageid": "64163063",
      "href": "https://km.sankuai.com/page/64163063",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("MOA/DLP白名单申请流程")]), _vm._v(" 。")]), _vm._v(" "), _c('p', [_vm._v("说明：因为微软已不维护Windows XP、Windows 2003、Windows 8系统，即将不支持维护Windows 10，所以"), _c('strong', [_vm._v("如果这些系统曝出存在新的漏洞，微软也不会对这些系统提供安全补丁")]), _vm._v("，存在很大的安全风险。对Windows用户，我们"), _c('strong', [_vm._v("强烈建议使用Windows10系统进行办公")]), _vm._v("。")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("5、临时不安装MOA的条件及申请流程")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("临时条件：产假、长期病假")]), _vm._v(" "), _c('p', [_vm._v("流程：请提交名单列表给信息安全部 jijuntao、pengzhengmao、wangzepeng05。")]), _vm._v(" "), _c('p', [_vm._v("说明：员工在返回岗位后，仍然需要安装MOA，否则"), _c('strong', [_vm._v("会影响对公司办公网络和业务系统的正常访问，影响员工正常办公")]), _vm._v("。")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("6、正在申请离职的员工是否可以不安装或是否可以申请白名单？")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("a、严禁正在申请离职的员工申请MOA和DLP白名单。")])]), _vm._v(" "), _c('p', [_vm._v("b、如已提交离职申请，但是工作交接还有一周以上的员工，"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("仍需安装MOA和DLP。")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("7、私人电脑是否需要安装公司MOA？")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("私人电脑如果用于正常办公，就需要安装公司的MOA。比如:有些同事的公司电脑、私人电脑都用于正常办公，那两台电脑都需要安装MOA。")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("8、如果MOA被其他同事扫码，该怎么处理？")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("说明：参考FAQ 3")]), _vm._v(" "), _c('p', [_vm._v("解决方法：将 当前同事 及 扫码同事 的mis号提交给 信息安全部 jijuntao、pengzhengmao、wangzepeng05 处理。")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("9、使用了已离职同事的电脑，MOA已安装好，该怎么处理？")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("将 当前同事 及 已离职同事 的mis号提交给信息安全部 jijuntao、pengzhengmao、wangzepeng05 处理。")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("10、非电脑设备用于办公，如手机、pad等，是否需要安装MOA？")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("MOA目前支持Windows 7，Windows 10及苹果电脑部署，暂不支持移动端部署。")]), _vm._v(" "), _c('p', [_vm._v("解决办法：由当事人领导提供名单列表，联系信息安全部 jijuntao、pengzhengmao、wangzepeng05 处理。")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("11、MOA阻断策略上线后，被限制访问处理方法")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("a、用户被阻断策略阻断后，会出现如下限制访问提示页面，根据提示检查自己电脑上MOA和DLP的安装和运行状态。")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("../assets/other_FAQ/other_FAQ_pic03.png"),
      "width": "900px",
      "height": "500px"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("b、针对不能立即安装MOA，但是又需要访问内部系统的用户，建议走临时白名单申请，请参考限制访问提示页面中白名单申请：【MOA: "), _c('a', {
    staticClass: "ct-link",
    staticStyle: {
      "color": "#1890ff"
    },
    attrs: {
      "data-auto_update": "0",
      "data-pageid": "",
      "href": "https://reg-sec.meituan.com/moa/bypass?token=moa",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("https://reg-sec.meituan.com/moa/bypass?token=moa")]), _vm._v(" 】临时申请白名单。")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("../assets/other_FAQ/other_FAQ_pic04.png"),
      "width": "700px",
      "height": "110px"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("c、请注意，白名单时效为四小时，四小时后就时效，请及时安装MOA。白名单只允许申请三次。")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("../assets/other_FAQ/other_FAQ_pic05.png"),
      "width": "750px",
      "height": "370px"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("d、用户完成安装MOA后，由于MOA数据同步需要10分钟左右，建议可先自行申请临时白名单保证当前可正常访问网络，再安装MOA。")]), _vm._v(" "), _c('p', [_vm._v("      白名单生效时间为五分钟，生效后，关闭浏览器所有页面后再重新打开需要访问的内部系统即可。")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("12、MOA已安装，仍被限制访问，如何解决？")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("a、判断大象扫码登录或申请白名单时间，以上生效时间分别为10分钟（MOA安装），5分钟（白名单申请）。")]), _vm._v(" "), _c('p', [_vm._v("b、查询mis号安装状态:"), _c('a', {
    staticClass: "ct-link",
    staticStyle: {
      "color": "#1890ff"
    },
    attrs: {
      "data-auto_update": "0",
      "data-pageid": "",
      "href": "https://report-mon.sankuai.com/report/api/check_status?mis_id=wangzepeng05",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("https://report-mon.sankuai.com/report/api/check_status?mis_id=wangzepeng05")]), _vm._v(" ，查看MOA和DLP的安装状态，是否DLP未正常安装。")]), _vm._v(" "), _c('p', [_vm._v("c、如果MOA安装时间，或者白名单申请时间已超过正常时间，MOA安装状态仍然是“N”，请联系信息安全部 wangzepeng05、jijuntao、pengzhengmao。")]), _vm._v(" "), _c('p', [_vm._v("d、如果mis号查询MOA安装状态为“Y”，员工仍被限制访问，请员工重启系统，重新打开Chrome浏览器，使用无痕模式尝试访问。")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("../assets/other_FAQ/other_FAQ_pic06.png"),
      "width": "250px",
      "height": "300px"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("e、彻底解决无法登陆的问题，请清除浏览器Cookie，具体方法可参考：")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "ct-link",
    staticStyle: {
      "color": "#1890ff"
    },
    attrs: {
      "data-auto_update": "0",
      "href": "https://jingyan.baidu.com/article/09ea3ede4a4127c0aede39a7.html",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("https://jingyan.baidu.com/article/09ea3ede4a4127c0aede39a7.html")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("13、覆盖安装未跳出签署协议")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("默认该电脑签署过一次MOA用户协议后，覆盖安装或升级，不会再跳出签署用户协议页面。")]), _vm._v(" "), _c('p', [_vm._v("除非彻底卸载MOA后的安装，才会跳出签署用户协议页面。")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("14、拒绝签署“安全管理客户端用户协议”")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("拒绝签署“安全管理客户端用户协议”，则表示退出MOA，MOA未正常运行，该电脑将无法登陆SSO，影响正常办公。")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("../assets/other_FAQ/other_FAQ_pic07.png"),
      "width": "900px",
      "height": "630px"
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("15、MOA版本过旧导致更新失败")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("MOA版本过旧在更新时会有更新失败的问题，请直接下载最新稳定版MOA进行覆盖安装即可。")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("16、已安装最新版本MOA，仍然被限制访问")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("如果当前检测MOA已经是最新版本，但仍然被限制访问。请重启电脑后再尝试访问内网。")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-451bae1c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/other_FAQ.vue
// module id = 642
// module chunks = 1